
import Image from "./Image";
import styled from "styled-components";
import { useIntl } from "react-intl";
const formater = (num, base = 1,per = 1) =>{
  return ((num/100/base) * per).toFixed(2)
}
export default function FeatureProcesses(
  {
    specialty =0,
    aesthetic =0,
    comfort=0,
    resilence =0,
    intlfn
  }
) {
  const getMessage = (id) =>{
    return intlfn.formatMessage({
      id
    })
  }
  return  <Processes>
  <div className="processWrapper process1">
    <div className="l">
      <Image
        width={"1.5rem"}
        height={"1.5rem"}
        src={"image/icons/icon1.png"}
        // fit={"contain"}
        alt={"icon1"}
        key={"icon1"}
      />
      <div className="t">{getMessage("pages.home.specialty_num") }</div>
      <div className="process">
        <div className="processInner" style={{width: formater(specialty,1000,100) + '%'}}></div>
      </div>
    </div>
    <div className="v">{formater(specialty)}</div>
  </div>
  <div className="processWrapper process2">
    <div className="l">
      <Image
        width={"1.5rem"}
        height={"1.5rem"}
        src={"image/icons/icon2.png"}
        // fit={"contain"}
        alt={"icon2"}
        key={"icon2"}
      />
      <div className="t"> {getMessage("pages.home.aesthetic_num")}</div>
      <div className="process">
        <div className="processInner" style={{width: formater(aesthetic,1000,100) + '%'}}></div>
      </div>
    </div>
    <div className="v">{formater(aesthetic) || 0} </div>
  </div>
  <div className="processWrapper process3">
    <div className="l">
      <Image
        width={"1.5rem"}
        height={"1.5rem"}
        src={"image/icons/icon3.png"}
        alt={"icon3"}
        key={"icon3"}
      />
      <div className="t">{getMessage("pages.home.comfort_num")} </div>
      <div className="process">
        <div className="processInner" style={{width: formater(comfort,1000,100) + '%'}}></div>
      </div>
    </div>
    <div className="v">{formater(comfort) || "0"} </div>
  </div>
  <div className="processWrapper process4">
    <div className="l">
      <Image
        width={"1.5rem"}
        height={"1.5rem"}
        src={"image/icons/icon4.png"}
        // fit={"contain"}
        alt={"icon4"}
        key={"icon4"}
      />
      <div className="t">{getMessage("弹性")} </div>
      <div className="process">
        <div className="processInner" style={{width: formater(resilence,2,100) + '%'}}></div>
      </div>
    </div>
    <div className="v">{formater(resilence) || "0"}</div>
  </div>
</Processes>
}

const Processes = styled.div`
  padding: 0 1.5rem;
  margin-top: .8rem;
  .processWrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;

    margin-bottom: .7rem;
  }
  .l {
    display: flex;
    align-items: center;
    flex: 1;
  }
  .t {
    font-style: normal;
    font-weight: 400;
    font-size: 1.2rem;
    line-height: 1.4rem;
    color: #000000;
    display: inline-block;
    padding: 0 .5rem 0 1.0rem;
    width: 5.0rem;
    text-align: left;
  }
  .v {
    font-style: normal;
    font-weight: 500;
    font-size: 1.3rem;
    line-height: 1.3rem;

    color: #000000;
    width: 4.0rem;
    text-align: right;
  }
  .process {
    flex: 1;
    align-self: stretch;
    .processInner {
      background: #ccd8db;
      border: .05rem solid #344362;
      border-radius: 1.0rem;
      height: 70%;
      width: 50%;
      margin-top: 2%;
      max-width: 100%;
    }
  }
`;
